import wbnbABI from "../../src/abis/wbnb.json";
import { addToast } from "@heroui/react";
import { rainbowKitConfig } from "../utils/config";
import {
  writeContract,
  waitForTransactionReceipt,
  readContract
} from "@wagmi/core";

const ApprovePlatformInteraction = async (
  erc20BAFAddress,
  transferProxyAddress,
  formattedTotalValue,
  setApprovalStatus,
  address
) => {
  try {
    setApprovalStatus("process");

    const allowance = await readContract(rainbowKitConfig, {
      abi: wbnbABI,
      address: erc20BAFAddress,
      functionName: "allowance",
      args: [address, transferProxyAddress]
    });

    if (Number(allowance) >= Number(formattedTotalValue)) {
      setApprovalStatus("done");
      addToast({
        title: "Already Approved",
        description: "You've already approved enough tokens for this platform.",
        color: "success",
        variant: "bordered"
      });
      return;
    }

    const txHash = await writeContract(rainbowKitConfig, {
      abi: wbnbABI,
      address: erc20BAFAddress,
      functionName: "approve",
      args: [transferProxyAddress, formattedTotalValue]
    });

    const receipt = await waitForTransactionReceipt(rainbowKitConfig, {
      hash: txHash,
      confirmations: 1
    });

    setApprovalStatus("done");
    addToast({
      title: "Approval Successful",
      description:
        "You have successfully approved the platform to interact with your tokens.",
      color: "success",
      variant: "bordered"
    });
  } catch (err) {
    console.error("Approval Error:", err);
    setApprovalStatus("yetToStart");

    const userRejected =
      err?.message?.includes("User rejected") ||
      err?.message?.includes("User denied");

    addToast({
      title: userRejected ? "Transaction Rejected" : "Approval Failed",
      description: userRejected
        ? "You rejected the transaction from your wallet."
        : err?.shortMessage ||
          err?.message ||
          "An error occurred during approval.",
      color: userRejected ? "warning" : "error",
      variant: "bordered"
    });
  }
};

export default ApprovePlatformInteraction;
